// React
import { useState } from "react";

// Internal
import { TableSortDirection } from "./table-constants";

export const useTableState = (initialSortField, initialSortDirection, initialColumns, initialSearch, initialFilterValues) => {
    const [search, setSearch] = useState(initialSearch || "");
    const [sort, setSort] = useState({ FieldName: initialSortField || "", Direction: initialSortDirection || TableSortDirection.Ascending });
    const [columns, setColumns] = useState(initialColumns || []);
    const [filterValues, setFilterValues] = useState(initialFilterValues || {});

    const changeSort = (fieldName) => {
        if (fieldName === sort.FieldName) {
            const direction = sort.Direction === TableSortDirection.Ascending ? TableSortDirection.Descending : TableSortDirection.Ascending;
            setSort({ FieldName: fieldName, Direction: direction });
        } else {
            setSort({ FieldName: fieldName, Direction: TableSortDirection.Ascending });
        }
    };

    const changeFilter = (fieldName, values) => {
        let newFilterValues = { ...filterValues };
        newFilterValues[fieldName] = values;
        setFilterValues(newFilterValues);
    };

    const clearFilterValues = () => {
        setFilterValues({});
    };

    return {
        Search: search,
        Sort: sort,
        Columns: columns,
        FilterValues: filterValues,
        SetSearch: setSearch,
        SetSort: changeSort,
        SetColumns: setColumns,
        SetFilterValues: changeFilter,
        ClearFilterValues: clearFilterValues
    };
};